import React from 'react';
import dayjs from 'dayjs';
import { FormControl, Box, FormHelperText } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

export default function DealOfferEndDateField({
  value,
  error,
  setValue,
  setError,
  minDate,
  maxDate,
}) {
  const handleChange = (value) => {
    setValue(value.format('L'));
  };

  return (
    <Box>
      <FormControl fullWidth>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label='Offering End Date'
            value={dayjs(value)}
            onChange={handleChange}
            aria-describedby='offer-end-date-helper-text'
            id='offer_end_date'
            onError={(newError) => setError(newError)}
            minDate={minDate}
            maxDate={maxDate}
          />
        </LocalizationProvider>

        {error ? (
          <FormHelperText id='offer-end-date-helper-text'>
            {dayjs(value).isAfter(maxDate)
              ? 'Offering end date too large.'
              : 'Offering end date must be after start date.'}
          </FormHelperText>
        ) : (
          <FormHelperText id='offer-end-date-helper-text'>
            Enter the date the offering will close.
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
